module.exports = __webpack_public_path__ + "img/cooperate_qy_07@2x.944fab05.png";